"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoringvillePopulationYou = void 0;
var Card_1 = require("../../Card");
var CardType_1 = require("../../CardType");
var Tags_1 = require("../../Tags");
var SelectSpace_1 = require("../../../inputs/SelectSpace");
var Resources_1 = require("../../../Resources");
var CardName_1 = require("../../../CardName");
var CardRenderer_1 = require("../../render/CardRenderer");
var Units_1 = require("../../../Units");
var BoringvillePopulationYou = (function (_super) {
    __extends(BoringvillePopulationYou, _super);
    function BoringvillePopulationYou() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.BORINGVILLE_POPULATION_YOU,
            tags: [Tags_1.Tags.CITY, Tags_1.Tags.BUILDING],
            cost: 22,
            productionBox: Units_1.Units.of({ megacredits: 2 }),
            metadata: {
                cardNumber: 'L424',
                description: 'Increase your M€ production 2 steps. Place a City tile.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) {
                        pb.megacredits(2);
                    }).nbsp.nbsp.city();
                }),
            },
        }) || this;
    }
    BoringvillePopulationYou.prototype.canPlay = function (player) {
        return player.game.board.getAvailableSpacesForCity(player).length > 0;
    };
    BoringvillePopulationYou.prototype.play = function (player) {
        return new SelectSpace_1.SelectSpace('Select space for city tile', player.game.board.getAvailableSpacesForCity(player), function (space) {
            player.game.addCityTile(player, space.id);
            player.addProduction(Resources_1.Resources.MEGACREDITS, 2);
            return undefined;
        });
    };
    return BoringvillePopulationYou;
}(Card_1.Card));
exports.BoringvillePopulationYou = BoringvillePopulationYou;
//# sourceMappingURL=BoringvillePopulationYou.js.map